import React from "react";
import "./Cards.css";

const Card1 = ({
  image,
  dotColor,
  backgroundColor,
  heading,
  description,
  containerStyle,
}) => {
  return (
    <div
      className="card__one_wrap"
      style={{ ...containerStyle, background: backgroundColor }}
    >
      <div className="card__one_header">
        <div
          className="card__one_headerdot"
          style={{ backgroundColor: dotColor }}
        ></div>
        <img src={image} className="card__one_headericn" alt="" />
      </div>
      <div className="card__one_heading">{heading}</div>
      <div className="card__one_description">{description}</div>
    </div>
  );
};

export default Card1;
